<template>
  <!-- TODO Change style property -->
  <v-content
    id="id"
    fluid
    tag="section"
    class="mx-5"
    style="color: black !important"
  >
    <slot></slot>
  </v-content>
</template>

<script>
export default {
  props: ["id"]
};
</script>

<style></style>
